import { Plan } from '@/types/plan';
import { defaultPlans } from '@/constants/defaults';
import { queryCollection } from './database/collections';

export async function getPlans(): Promise<Plan[]> {
  return queryCollection<Plan>(
    'plans',
    'basePrice',
    defaultPlans
  );
}

export async function mapPlanTextToId(text: string): Promise<string> {
  try {
    const cleanText = text.trim();
    const plans = await getPlans();
    const plan = plans.find(p => p.name === cleanText);

    if (!plan) {
      console.warn(`No matching plan found for text: ${text}`);
      return 'basic';
    }

    return plan.id;
  } catch (error) {
    console.warn('Error mapping plan text to ID:', error);
    return 'basic';
  }
}